import { Typography } from '@mui/material';
import React from 'react';

/**
 * Page name on list and settings screens (CP-5562).
 * Same type as Trips, Campaigns, and Notifications: 20px, weight 500.
 */
const PageHeading = ({ children, sx }) => (
    <Typography fontSize={20} fontWeight={500} lineHeight="24px" sx={sx}>
        {children}
    </Typography>
);

export default PageHeading;
